<template>
  <section class="content-block">
    <div class="max-w-full">
      <div class="flex gap-5 max-md:flex-col max-md:gap-0 max-md:items-center">
        <NuxtImg
          v-if="image"
          provider="strapi"
          :src="image.url"
          :alt="image.alternativeText"
          width="215"
          height="245"
          class="grow shrink-0 max-w-full max-md:mt-10 max-md:w-[144px]"
        />
        <div class="flex flex-col ml-5">
          <div class="content">
            <h2 class="heading">{{ content.heading }}</h2>
            <BaseRichText class="text" :content="content.content" />
            <BaseCtaLink :field="content.cta" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const props = defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {};
    },
  },
});

const { getImageData } = useStrapiUtils();
// console.log("props.content.image", props.content.image);
const image: any = getImageData(props.content.image);
</script>
<style scoped lang="scss">
.content-block {
  @apply flex justify-center items-center px-16 py-12 w-full bg-zinc-100 max-md:px-5 max-md:max-w-full;

  .content {
    @apply flex flex-col items-center self-stretch my-auto font-semibold text-center max-md:mt-10 max-md:max-w-full;
    .heading {
      @apply text-primary uppercase;
      @screen md {
        @apply text-4xl font-semibold;
      }
    }
    .text {
      :deep() {
        p,
        strong {
          @apply self-stretch mt-3.5 text-2xl max-md:max-w-full;
        }
      }
    }
  }
}
</style>
